import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import Service from './service'

export const getMaxDate = createAsyncThunk(
  'portfolioInsights/segment/getMaxDate',
  async (params, { rejectWithValue }) => {
    try {
      const response = await Service.getMaxDate(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getHighLight = createAsyncThunk(
  'portfolioInsights/segment/getHighLight',
  async (params, { rejectWithValue }) => {
    try {
      const response = await Service.getHighLight(params)
      if (response.success) return response.data

      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
